<template>
  <a-card :bordered="false">
    <!-- 顶部筛选区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="厂区编号">
              <a-input v-model.trim="queryParam.code" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="厂区名称">
              <a-input v-model.trim="queryParam.name" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="8" :sm="24">
              <a-form-item label="所属企业">
                <a-select v-model="queryParam.corpCompanyId" default-value="0" placeholder="请选择">
                  <a-select-option value>全选</a-select-option>
                  <a-select-option
                    v-for="(item, index) in corpCompanySelect"
                    :key="index"
                    :value="item.id"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button>
      <a-button
        type="dashed"
        v-if="config.hasAlert"
        @click="tableOption"
      >{{ optionAlertShow && '关闭' || '开启' }} alert</a-button>
    </div>

    <!-- 数据网格 -->
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :scroll="{ x:1530 }"
      :alert="options.alert"
      :rowSelection="options.rowSelection"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a @click="handleDel(record)">删除</a>
      </span>
    </s-table>

    <a-modal
      title="编辑"
      style="top: 20px;"
      :width="560"
      v-model="visible"
      @ok="handleOk"
      :confirmLoading="confirmLoading"
    >
      <a-form :form="form">
        <a-form-item label="厂区编号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            placeholder="请选择厂区编号"
            v-decorator="['code',
            { initialValue: mdl.code, rules: [{ required: true, message: '请选择厂区编号'}]}]"
          >
            <a-select-option
              v-for="(item, index) in fcodeSelect"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="厂区名称" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            placeholder="请输入厂区名称"
            v-decorator="['name',
            { initialValue: mdl.name, rules: [{ required: true, message: '请输入厂区名称'}]}]"
          />
        </a-form-item>

        <a-form-item label="所属企业" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            v-model="mdl.corpCompanyId"
            placeholder="请选择所属企业"
          >
            <a-select-option
              v-for="(item, index) in corpCompanySelect"
              :key="index"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="厂址" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-textarea
            v-model="mdl.address"
            placeholder="请输入厂址"
            :autosize="{ minRows: 3, maxRows: 5 }"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import { factoryPage, factoryUpdate, factorySave, factoryDelete, corpCompanyList } from '../../api/basic'
import storage from '@/utils/storage'
import { formatDate } from '@/utils/date'
export default {
  name: 'Factory',
  components: {
    STable
  },
  data() {
    return {
      pageSizeOptionsList:['10'],
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' },
           width: '40px',
          fixed:"left"
        },
        {
          title: '厂区编号',
          dataIndex: 'code',
          width: '120px',
        },
        {
          title: '厂区名',
          dataIndex: 'name',
           width: '100px',
        },
        {
          title: '所属企业',
          dataIndex: 'corpCompanyName',
          width: '250px',
        },
        {
          title: '厂址',
          dataIndex: 'address',
           width: '250px',
        },
        {
          title: '创建人',
          dataIndex: 'createId',
          width: '120px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
         {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '200px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
         {
          title: '更新人',
          dataIndex: 'updateId',
          width: '120px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '200px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
        {
          title: '操作',
          width: '130px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed:"right"
        }
      ],

      // 所属菜单下拉
      corpCompanySelect: null,
      // 厂区编号下拉
      fcodeSelect: null,
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return factoryPage(Object.assign(parameter, this.queryParam)).then(res => {
          return res.data
        })
      },

      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: {
          show: false,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true
    }
  },
  created() {
    this.tableOption()
    this.loadSelect()
  },
  methods: {
    loadSelect() {
      // 从后台拉去下拉列表数据
      new Promise(resolve => {
        const data = corpCompanyList({}).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.corpCompanySelect = res
      })
      this.fcodeSelect = this.$store.getters.codeList.basic_factory_code
    },
    filterOption(input, option) {
      // 用于下拉列表可搜索
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: false,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleEdit(record) {
      this.mdl = Object.assign({}, record)
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleAdd() {
      this.mdl = {}
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        Object.assign(this.mdl, values)
        if (!err) {
          this.confirmLoading = true
          if (this.mdl.id !== undefined) {
            factoryUpdate(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                this.confirmLoading = false
              })
          } else {
            factorySave(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                this.confirmLoading = false
              })
          }
        }
      })
    },
    handleDel(record) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要删除吗?',
        onOk() {
          return factoryDelete({ ids: record.id })
            .then(res => {
              if (res.code === '0') {
                nthis.$refs.table.refresh()
              }
            })
            .catch(e => {
              console.log(e)
            })
            .finally(() => {})
        },
        onCancel() {}
      })
    },
    handleFactoryDoor(record) {
      storage.save('cache-FactoryDoor', JSON.stringify(record))
      this.$router.push({ name: 'FactoryDoor' })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    }
  }
}
</script>
